import {RouteContext} from "../../RouteContext";
import {Styles} from "../common/Styles";
import {ShoppingDataTransferObject} from "../../../model/dto/content/ShoppingDataTransferObject";
import {
    InputStringStatePair,
    StatePair,
    useError,
    useInputString,
    useStatePair, useUndefined
} from "../../../type/States";
import {Button, Field, FieldProps, Input, Radio, RadioGroup} from "@fluentui/react-components";
import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingIO} from "../../../io/content/ShoppingIO";
import {Column, Row} from "../common/Layout";
import React from "react";
import {useAdminId} from "../../../stores/useAdminId";

export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()
    const {adminId} = useAdminId();

    if(!adminId) throw new Error("관리자 아이디가 지정되지 않았습니다.");

    const inputStates: Record<keyof ShoppingDataTransferObject.Post, InputStringStatePair> = {
        isActive: useInputString(''),
        exposedAt: useInputString(''),
        catalogRank: useInputString(''),
        mid: useInputString(''),
        reviewCount: useInputString(''),
        reviewScore: useInputString(''),
        mallCount: useInputString(''),
        storeName: useInputString(''),
        productName: useInputString(''),
        productImageUrl: useInputString(''),
        productNumber: useInputString(''),
        answer: useInputString(''),
        productPrice: useInputString(''),
        productUrl: useInputString(''),
        mainKeywordString: useInputString(''),
        mallSequence: useInputString(''),
        categoryId: useInputString(''),
        catalogMid: useInputString(''),
        catalogProductName: useInputString(''),
        catalogLowestPrice: useInputString(''),
        catalogDiscountedPrice: useInputString(''),
        catalogDeliveryFee: useInputString(''),
        amount: useInputString(''),
    }
    const inputValidationStates: Record<keyof ShoppingDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        isActive: useStatePair<FieldProps['validationState']>('none'),
        exposedAt: useStatePair<FieldProps['validationState']>('none'),
        catalogRank: useStatePair<FieldProps['validationState']>('none'),
        mid: useStatePair<FieldProps['validationState']>('none'),
        reviewCount: useStatePair<FieldProps['validationState']>('none'),
        reviewScore: useStatePair<FieldProps['validationState']>('none'),
        mallCount: useStatePair<FieldProps['validationState']>('none'),
        storeName: useStatePair<FieldProps['validationState']>('none'),
        productName: useStatePair<FieldProps['validationState']>('none'),
        productImageUrl: useStatePair<FieldProps['validationState']>('none'),
        productNumber: useStatePair<FieldProps['validationState']>('none'),
        answer: useStatePair<FieldProps['validationState']>('none'),
        productPrice: useStatePair<FieldProps['validationState']>('none'),
        productUrl: useStatePair<FieldProps['validationState']>('none'),
        mainKeywordString: useStatePair<FieldProps['validationState']>('none'),
        mallSequence: useStatePair<FieldProps['validationState']>('none'),
        categoryId: useStatePair<FieldProps['validationState']>('none'),
        catalogMid: useStatePair<FieldProps['validationState']>('none'),
        catalogProductName: useStatePair<FieldProps['validationState']>('none'),
        catalogLowestPrice: useStatePair<FieldProps['validationState']>('none'),
        catalogDiscountedPrice: useStatePair<FieldProps['validationState']>('none'),
        catalogDeliveryFee: useStatePair<FieldProps['validationState']>('none'),
        amount: useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.isActive.setValue('none')
        inputValidationStates.exposedAt.setValue('none')
        inputValidationStates.catalogRank.setValue('none')
        inputValidationStates.mid.setValue('none')
        inputValidationStates.reviewCount.setValue('none')
        inputValidationStates.reviewScore.setValue('none')
        inputValidationStates.mallCount.setValue('none')
        inputValidationStates.storeName.setValue('none')
        inputValidationStates.productName.setValue('none')
        inputValidationStates.productImageUrl.setValue('none')
        inputValidationStates.productNumber.setValue('none')
        inputValidationStates.answer.setValue('none')
        inputValidationStates.productPrice.setValue('none')
        inputValidationStates.productUrl.setValue('none')
        inputValidationStates.mainKeywordString.setValue('none')
        inputValidationStates.mallSequence.setValue('none')
        inputValidationStates.categoryId.setValue('none')
        inputValidationStates.catalogMid.setValue('none')
        inputValidationStates.catalogProductName.setValue('none')
        inputValidationStates.catalogLowestPrice.setValue('none')
        inputValidationStates.catalogDiscountedPrice.setValue('none')
        inputValidationStates.catalogDeliveryFee.setValue('none')
        inputValidationStates.amount.setValue('none')
        try {
            const dto: ShoppingDataTransferObject.Post = {
                isActive:  DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'isActive', inputStates.isActive.value, () => inputValidationStates.isActive.setValue('error')),
                exposedAt: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'exposedAt', inputStates.exposedAt.value, () => inputValidationStates.exposedAt.setValue('error')),
                catalogRank: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogRank', inputStates.catalogRank.value, () => inputValidationStates.catalogRank.setValue('error')),
                mid: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'mid', inputStates.mid.value, () => inputValidationStates.mid.setValue('error')),
                reviewCount: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'reviewCount', inputStates.reviewCount.value, () => inputValidationStates.reviewCount.setValue('error')),
                reviewScore: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'reviewScore', inputStates.reviewScore.value, () => inputValidationStates.reviewScore.setValue('error')),
                mallCount: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'mallCount', inputStates.mallCount.value, () => inputValidationStates.mallCount.setValue('error')),
                storeName: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'storeName', inputStates.storeName.value, () => inputValidationStates.storeName.setValue('error')),
                productName: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'productName', inputStates.productName.value, () => inputValidationStates.productName.setValue('error')),
                productImageUrl: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'productImageUrl', inputStates.productImageUrl.value, () => inputValidationStates.productImageUrl.setValue('error')),
                productNumber: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'productNumber', inputStates.productNumber.value, () => inputValidationStates.productNumber.setValue('error')),
                answer: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'answer', inputStates.answer.value, () => inputValidationStates.answer.setValue('error')),
                productPrice: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'productPrice', inputStates.productPrice.value, () => inputValidationStates.productPrice.setValue('error')),
                productUrl: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'productUrl', inputStates.productUrl.value, () => inputValidationStates.productUrl.setValue('error')),
                mainKeywordString: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'mainKeywordString', inputStates.mainKeywordString.value, () => inputValidationStates.mainKeywordString.setValue('error')),
                mallSequence: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'mallSequence', inputStates.mallSequence.value, () => inputValidationStates.mallSequence.setValue('error')),
                categoryId: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'categoryId', inputStates.categoryId.value, () => inputValidationStates.categoryId.setValue('error')),
                catalogMid: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogMid', inputStates.catalogMid.value, () => inputValidationStates.catalogMid.setValue('error')),
                catalogProductName: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogProductName', inputStates.catalogProductName.value, () => inputValidationStates.catalogProductName.setValue('error')),
                catalogLowestPrice: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogLowestPrice', inputStates.catalogLowestPrice.value, () => inputValidationStates.catalogLowestPrice.setValue('error')),
                catalogDiscountedPrice: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogDiscountedPrice', inputStates.catalogDiscountedPrice.value, () => inputValidationStates.catalogDiscountedPrice.setValue('error')),
                catalogDeliveryFee: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'catalogDeliveryFee', inputStates.catalogDeliveryFee.value, () => inputValidationStates.catalogDeliveryFee.setValue('error')),
                amount: DataTransferObjectValidation.validate(ShoppingDataTransferObject.Post.validation, 'amount', inputStates.amount.value, () => inputValidationStates.amount.setValue('error')),
            }

            ShoppingIO.post(dto)
                .then(() => window.alert('추가되었습니다.'))
                .catch(postErrorState.setDefinedValue)
        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.isActive}
                validationState={inputValidationStates.isActive.value}>
                <RadioGroup
                    value={inputStates.isActive.value}
                    onChange={
                        (_, data) => inputStates.isActive.setValue(data.value)
                    }>
                    <Radio value="true" label="활성화" />
                    <Radio value="false" label="비활성화" />
                </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.exposedAt}
                validationState={inputValidationStates.exposedAt.value}>
                <Input
                    value={inputStates.exposedAt.value}
                    onChange={inputStates.exposedAt.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogRank}
                validationState={inputValidationStates.catalogRank.value}>
                <Input
                    value={inputStates.catalogRank.value}
                    onChange={inputStates.catalogRank.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.mid}
                validationState={inputValidationStates.mid.value}>
                <Input
                    value={inputStates.mid.value}
                    onChange={inputStates.mid.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.reviewCount}
                validationState={inputValidationStates.reviewCount.value}>
                <Input
                    value={inputStates.reviewCount.value}
                    onChange={inputStates.reviewCount.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.reviewScore}
                validationState={inputValidationStates.reviewScore.value}>
                <Input
                    value={inputStates.reviewScore.value}
                    onChange={inputStates.reviewScore.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.mallCount}
                validationState={inputValidationStates.mallCount.value}>
                <Input
                    value={inputStates.mallCount.value}
                    onChange={inputStates.mallCount.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.storeName}
                validationState={inputValidationStates.storeName.value}>
                <Input
                    value={inputStates.storeName.value}
                    onChange={inputStates.storeName.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.productName}
                validationState={inputValidationStates.productName.value}>
                <Input
                    value={inputStates.productName.value}
                    onChange={inputStates.productName.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.productImageUrl}
                validationState={inputValidationStates.productImageUrl.value}>
                <Input
                    value={inputStates.productImageUrl.value}
                    onChange={inputStates.productImageUrl.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.productNumber}
                validationState={inputValidationStates.productNumber.value}>
                <Input
                    value={inputStates.productNumber.value}
                    onChange={inputStates.productNumber.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.answer}
                validationState={inputValidationStates.answer.value}>
                <Input
                    value={inputStates.answer.value}
                    onChange={inputStates.answer.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.productPrice}
                validationState={inputValidationStates.productPrice.value}>
                <Input
                    value={inputStates.productPrice.value}
                    onChange={inputStates.productPrice.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.productUrl}
                validationState={inputValidationStates.productUrl.value}>
                <Input
                    value={inputStates.productUrl.value}
                    onChange={inputStates.productUrl.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.mainKeywordString}
                validationState={inputValidationStates.mainKeywordString.value}>
                <Input
                    value={inputStates.mainKeywordString.value}
                    onChange={inputStates.mainKeywordString.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.mallSequence}
                validationState={inputValidationStates.mallSequence.value}>
                <Input
                    value={inputStates.mallSequence.value}
                    onChange={inputStates.mallSequence.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.categoryId}
                validationState={inputValidationStates.categoryId.value}>
                <Input
                    value={inputStates.categoryId.value}
                    onChange={inputStates.categoryId.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogMid}
                validationState={inputValidationStates.catalogMid.value}>
                <Input
                    value={inputStates.catalogMid.value}
                    onChange={inputStates.catalogMid.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogProductName}
                validationState={inputValidationStates.catalogProductName.value}>
                <Input
                    value={inputStates.catalogProductName.value}
                    onChange={inputStates.catalogProductName.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogLowestPrice}
                validationState={inputValidationStates.catalogLowestPrice.value}>
                <Input
                    value={inputStates.catalogLowestPrice.value}
                    onChange={inputStates.catalogLowestPrice.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogDiscountedPrice}
                validationState={inputValidationStates.catalogDiscountedPrice.value}>
                <Input
                    value={inputStates.catalogDiscountedPrice.value}
                    onChange={inputStates.catalogDiscountedPrice.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Put.description.catalogDeliveryFee}
                validationState={inputValidationStates.catalogDeliveryFee.value}>
                <Input
                    value={inputStates.catalogDeliveryFee.value}
                    onChange={inputStates.catalogDeliveryFee.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingDataTransferObject.Post.description.amount}
                validationState={inputValidationStates.amount.value}>
                <Input
                    value={inputStates.amount.value}
                    onChange={inputStates.amount.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}